export default __webpack_public_path__ + "static/pregunta-2-4959f05a667775f5a4bbfbcc6a6b360c.png";